import PocketBase from 'pocketbase';

// Default to local PocketBase if env var is not set
const url = process.env.REACT_APP_POCKETBASE_URL || 'http://127.0.0.1:8090';
const client = new PocketBase(url);

// Optional: Enable auto-cancellation of pending requests
client.autoCancellation(false);

export default client;
